/* ########### CONIFUGRATION ########### */

activeCampaignFormMessage = "<b> <b> Dir gefällt diese Übung? <br>Erhalte jetzt 100% kostenlos weitere Übungen inkl. Lösungen! "
activeCampaignFormLink = 'https://testhelden.activehosted.com/f/56';
activeCampaignFormWidth = '100%';
activeCampaignFormMaxWidth = '500px';
activeCampaignFormHeight = '300px';
refererParameterName = "FORM_URL" // default: FORM_URL

showACForm = () => {
    currentURL = getCurrentURL()
    clearView()
    addACForm(currentURL)
    showACMessage()
}


function getCurrentURL() {
    var url = new URL(window.location.href);
    console.log(`iframe will be embedded in url ${url}`)
    return url
}


function addURLToIframe(url) {
    console.log("adding url to iframe as parameter")
    iframe = document.getElementById('ac-iframe')
    iframe.src = iframe.src + `?${refererParameterName}=${url}`
    console.log(`iframe.src: ${iframe.src}`)
} 


function addACForm(currentURL) {
    console.log('ActiveCampaign: adding ACForm to body')
    body = document.getElementsByTagName('body')[0]
    body.style.textAlign = "center"
    body.innerHTML = ""
    body.margin = "0 auto"
    
    console.log('ActiveCampaign: creating iframe')
    acForm = document.createElement('iframe')
    acForm.src = activeCampaignFormLink
    acForm.id = 'ac-iframe'
    acForm.width = activeCampaignFormWidth
    acForm.height = activeCampaignFormHeight
    acForm.style.maxWidth = activeCampaignFormMaxWidth
    acForm.frameborder = '0'
    acForm.scrolling = 'no'
    acForm.style.border = 'none'
    acForm.style.margin = "0 auto"
    acForm.style.borderRadius = "15px"

    console.log('ActiveCampaign: adding iframe to body')
    body.appendChild(acForm)
    addURLToIframe(currentURL)
}

function showACMessage() {
    console.log('ActiveCampaign: showing Message')
    body = document.getElementsByTagName('body')[0]
    body.style.backgroundColor = "#FFFFFF"
    message = document.createElement('p')
    message.id = "activeCampaignFormMessage"
    message.innerHTML = activeCampaignFormMessage
    message.style.marginTop = "1em"
    
    body.insertBefore(message, body.firstChild)
}

function clearView () {
    console.log('clearing View')
    body = document.getElementsByTagName('body')[0]
    body.innerHTML = ""
    
}

